// import auth from '@/utils/auth'
import { login, getToken, setToken, getUsercode, setUsercode, removeToken, removeUserCode, setItem, getItem, removeItem, getInfo } from '@/utils/auth'

const BASE_SECRET = 'ehfiKKwduR9EL569eBqoFIlyxfuWASXFqHz1KI8ekJw'

const state = {
  // token: auth.getToken(),
  // usercode: auth.getUsercode(),
  // username: auth.getItem('username'),
  // department: auth.getItem('department'),
  // avatar: auth.getItem('avatar'),
  // user_type: '',
  // work_type: '',
  // approval: auth.getItem('approval'),
  // roles: []
  token: getToken(),
  usercode: getUsercode(),
  username: getItem('username'),
  department: getItem('department'),
  avatar: getItem('avatar'),
  user_type: '',
  work_type: '',
  approval: getItem('approval'),
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERCODE: (state, usercode) => {
    state.usercode = usercode
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
  SET_DEPARTMENT: (state, department) => {
    state.department = department
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_APPROVAL: (state, approval) => {
    state.approval = approval
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_POINT_ADMIN_POWER: (state, point_admin_power) => {
    state.point_admin_power = point_admin_power
  }
}
const actions = {
  // user login
  login({ commit }, usercode) {
    return new Promise((resolve, reject) => {
      login({ user_code: usercode, secret: BASE_SECRET }).then(response => {
        commit('SET_USERCODE', usercode)
        commit('SET_TOKEN', response.token)
        setUsercode(usercode)
        setToken(response.token)
        this.dispatch('user/getInfo', usercode)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get user info
  getInfo({ commit }, usercode) {
    return new Promise((resolve, reject) => {
      getInfo({ user_code: usercode }).then(response => {
        const { data } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { user_name, department, avatar, approval } = data
        commit('SET_USERNAME', user_name)
        commit('SET_DEPARTMENT', department)
        commit('SET_AVATAR', avatar)
        commit('SET_APPROVAL', approval)
        setItem('username', user_name)
        setItem('department', department)
        setItem('avatar', avatar)
        setItem('approval', approval)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({ commit }) {
    commit('SET_USERCODE', '')
    commit('SET_TOKEN', '')
    commit('SET_ROLES', [])
    removeToken()
    removeUserCode()
    removeItem()
  }

  // getUserAuthority({ commit }, usercode) {
  //   return new Promise((resolve, reject) => {
  //     getUserAuthority((usercode)).then(response => {
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
